'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RequiredAsterisk = require('../RequiredAsterisk');

var _RequiredAsterisk2 = _interopRequireDefault(_RequiredAsterisk);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Label(props) {
  var label = props.label,
      required = props.required,
      inputId = props.inputId,
      id = props.id;

  var getLabelClassNames = function getLabelClassNames() {
    var readOnly = props.readOnly,
        hideLabel = props.hideLabel;
    return (0, _classnames2["default"])('rainbow-lookup_input-label', {
      'rainbow-lookup_input-label-read-only': readOnly,
      'rainbow-picklist_input-label--hide': hideLabel
    });
  };

  return _react2["default"].createElement('label', {
    className: getLabelClassNames(),
    htmlFor: inputId,
    id: id
  }, _react2["default"].createElement(_RequiredAsterisk2["default"], {
    required: required
  }), label);
}

Label.propTypes = {
  label: _propTypes2["default"].node,
  required: _propTypes2["default"].bool.isRequired,
  inputId: _propTypes2["default"].string.isRequired,
  readOnly: _propTypes2["default"].bool.isRequired,
  id: _propTypes2["default"].string,
  hideLabel: _propTypes2["default"].bool
};
Label.defaultProps = {
  id: undefined,
  label: null,
  hideLabel: false
};